export const getCanKickParticipants = (manifest) =>
    manifest?.canKickParticipants ?? false;

export const getActiveWaitingRoom = (manifest) =>
    manifest?.activeWaitingRoom ?? false;

export const getAllowJoinWithoutModerator = (manifest) =>
    manifest?.allowJoinWithoutModerator ?? false;
